var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPluralIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 34,
    viewBox: "0 0 20 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.305 34H0.0545746L0 10.2308V8.5428C0 3.82457 4.03852 0 9.01766 0H20V25.4538C20 30.1549 15.9936 33.9692 11.0337 33.9966H10.305V34Z",
    fill: "#FF5E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78979 31.7368C6.03859 31.7368 7.12366 30.4494 7.12366 28.8607V11.686C5.87487 11.686 4.78979 12.9734 4.78979 14.5622V31.7368Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8313 26.3815C10.0801 26.3815 11.1652 25.0941 11.1652 23.4986V17.7703C9.91637 17.7703 8.8313 19.0577 8.8313 20.6464V26.385V26.3815Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2103 17.1882C13.9615 17.1882 12.8765 18.4756 12.8765 20.0644V22.6632C14.1253 22.6632 15.2103 20.9135 15.2103 19.3248V17.1882Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8313 16.6337C10.0801 16.6337 11.1652 15.3463 11.1652 13.7508V8.02246C9.91637 8.02246 8.8313 9.30987 8.8313 10.8986V16.6372V16.6337Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2103 10.9465C13.9615 10.9465 12.8765 12.2339 12.8765 13.8227V16.4215C14.1253 16.4215 15.2103 14.6718 15.2103 13.0831V10.9465Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2103 4.42358C13.9615 4.42358 12.8765 5.711 12.8765 7.29972V9.89851C14.1253 9.89851 15.2103 8.14886 15.2103 6.56014V4.42358Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluralIcon);
export default __webpack_public_path__ + "static/media/plural-icon.368309f19cd61ba1c76f064fcdc4727d.svg";
export { ForwardRef as ReactComponent };